"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataCenter = exports.getAllDataCenterLocations = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var dataCenterMappings = {
  north_america: ['dallas', 'lynnwood', 'sea', 'seapr1', 'us',
  // include xpd manifest names
  'impl-us', 'prod-us'],
  us2: ['us2',
  // include xpd manifest names
  'prod-us2'],
  emea: ['amsdr1', 'amsterdam', 'emea', 'par', 'parim1', 'paris', 'parpr1',
  // include xpd manifest names
  'impl-eu', 'prod-eu'],
  eu2: ['eu2',
  // include xpd manifest names
  'prod-eu2'],
  china: ['beijing', 'beipr1', 'china', 'cn',
  // include xpd manifest names
  'prod-china'],
  public_sector: ['pscc', 'public_sector', 'uspscc',
  // include xpd manifest names
  'prod-pscc']
};
var getAllDataCenterLocations = exports.getAllDataCenterLocations = function getAllDataCenterLocations() {
  var locations = [];
  var dataCenters = (0, _keys["default"])(dataCenterMappings);
  for (var i = 0; i < dataCenters.length; i += 1) {
    var _context;
    locations = (0, _concat["default"])(_context = []).call(_context, (0, _toConsumableArray2["default"])(locations), (0, _toConsumableArray2["default"])(dataCenterMappings[dataCenters[i]]));
  }
  return locations;
};
var getDataCenter = exports.getDataCenter = function getDataCenter(location) {
  var dataCenterLocation = (location || '').toLowerCase();
  var dataCenters = (0, _keys["default"])(dataCenterMappings);
  for (var i = 0; i < dataCenters.length; i += 1) {
    var _context2;
    if ((0, _some["default"])(_context2 = dataCenterMappings[dataCenters[i]]).call(_context2, function (element) {
      return element === dataCenterLocation;
    })) {
      return dataCenters[i];
    }
  }
  return '';
};